import { render, staticRenderFns } from "./LeaderDetail.vue?vue&type=template&id=32efe1bc&scoped=true&"
import script from "./LeaderDetail.vue?vue&type=script&lang=js&"
export * from "./LeaderDetail.vue?vue&type=script&lang=js&"
import style0 from "./LeaderDetail.vue?vue&type=style&index=0&id=32efe1bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32efe1bc",
  null
  
)

export default component.exports